<template>
  <main class="main">
    <div class="main__body">
      <div class="main__block">
        <div class="block__main">
          <h2 class="section-title">Студенты</h2>
          <table class="tbl">
            <thead>
            <tr>
              <th>Имя</th>
              <th>Результат</th>
              <th>Проверить ответы</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="student in students" :key="student.id">
              <td>{{ student.name }}</td>
              <td>{{ student.result ?? '—' }}</td>
              <td>
                <button
                    class="link link--gray"
                    type="button"
                    @click.stop="goToStudent(student.id)"
                >
                  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor">
                    <path d="M2.633 8.879a.667.667 0 01-1.264-.423c-.014.04 0-.001 0-.001.023-.074.05-.146.082-.216a6.87 6.87 0 01.24-.508 7.355 7.355 0 011.067-1.515C3.78 5.103 5.45 4 8 4s4.22 1.103 5.24 2.216c.545.597.987 1.28 1.308 2.023a2.8 2.8 0 01.06.15c.005.011.018.08.031.147.012.061.023.12.027.13 0 0 .112.445-.456.633a.667.667 0 01-.843-.419v-.004l-.009-.021a4.905 4.905 0 00-.23-.502 5.968 5.968 0 00-.87-1.236C11.445 6.231 10.115 5.333 8 5.333c-2.116 0-3.446.898-4.26 1.784a5.97 5.97 0 00-1.06 1.634l-.04.104-.008.024z"/>
                    <path d="M5.334 9.333a2.667 2.667 0 115.333 0 2.667 2.667 0 01-5.333 0z"/>
                  </svg>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { DiagnosticRepository } from '@/repositories'

const route = useRoute()
const router = useRouter()

const students = ref([])

onMounted(async () => {
  const res = await DiagnosticRepository.getStudents(route.params.organizationId)
  students.value = res.data.students
})

function goToStudent(studentId) {
  router.push({ name: 'expert.diagnostic.results.view', params: { studentId } })
}
</script>
